import { render, staticRenderFns } from "./TrendyolChannelMenu.vue?vue&type=template&id=3c8a37cc&scoped=true"
import script from "./TrendyolChannelMenu.vue?vue&type=script&lang=js"
export * from "./TrendyolChannelMenu.vue?vue&type=script&lang=js"
import style0 from "./TrendyolChannelMenu.vue?vue&type=style&index=0&id=3c8a37cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8a37cc",
  null
  
)

export default component.exports